
export const buildTaxBreakdown = (
  taxCategory,
  taxAmount,
  isTaxOnTax = "NO",
  description,
  hotelId,
  bookingId
) => {
  if (!taxCategory) return undefined;

  return [
    {
      tax_id: typeof taxCategory.id === "string" ? parseInt(taxCategory.id, 10) : taxCategory.id,
      tax_name: taxCategory.name,
      tax_percentage: taxCategory.percentage,
      tax_percentage_backup: taxCategory.percentage,
      tax_amount: taxAmount,
      tax_amount_backup: taxAmount,
      tax_province: taxCategory.province,
      is_tax_on_tax: isTaxOnTax,
      ...(description ? { description } : {}),
      ...(hotelId ? { hotel_id: hotelId } : {}),
      ...(bookingId ? { booking_id: bookingId } : {}),
    },
  ];
};


export const buildServiceItemPayload = (params) => {
  const {
    serviceDate,
    serviceDesc,
    serviceAmount,
    serviceAmountType,
    serviceTax,
    taxCategory,
    isTaxOnTax = "NO",
  } = params;

  const taxBreakdown = buildTaxBreakdown(
    taxCategory,
    parseFloat(serviceTax) || 0,
    isTaxOnTax
  );

  return {
    service_date: serviceDate,
    service_desc: serviceDesc,
    service_amount: serviceAmount,
    service_amount_type: serviceAmountType,
    service_tax: serviceTax,
    ...(taxBreakdown ? { tax_breakdown: taxBreakdown } : {}),
  };
};


export const buildAddonPayload = (item, taxCategory, hotelId, bookingId) => {
  const totalWithoutTax = item.priceWithoutTax * item.quantity;
  const taxAmount = totalWithoutTax * (item.taxPercentage / 100);
  const priceWithTax = totalWithoutTax + taxAmount;
  const effectiveTaxCategory = taxCategory || {
    id: 0,
    name: 'Generic Tax',
    percentage: item.taxPercentage,
    province: '',
  };

  const taxBreakdown = buildTaxBreakdown(
    effectiveTaxCategory,
    taxAmount,
    "NO",
    item.description,
    hotelId,
    bookingId
  );

  return {
    id: item.id,
    name: item.name,
    description: item.description || '',
    quantity: item.quantity,
    priceWithoutTax: item.priceWithoutTax,
    taxPercentage: item.taxPercentage,
    priceWithTax: priceWithTax,
    tax_breakdown: taxBreakdown,
  };
};
